import { BodyText, Flex, Link } from '@bamboohr/fabric';
import { RefObject, useState } from 'react';
import { ChatLogRow } from './chatLogRow';
import ChatPromptInput from './ChatPromptInput';
import { ChatLog } from 'src/pages/home/home.types';
import { useLlmStore } from 'src/store';

interface ChatLogsProps {
	chatLog: ChatLog[];
	chatLogRef: RefObject<HTMLDivElement>;
	handleSubmit: (target: HTMLTextAreaElement) => void;
	hasPrinted: boolean;
	setHasPrinted: (hasPrinted: boolean) => void;
}

export const ChatLogs = ({
	chatLog,
	chatLogRef,
	handleSubmit,
	hasPrinted,
	setHasPrinted,
}: ChatLogsProps) => {
	const [isPrinting, setIsPrinting] = useState(false);
	const llmLabel = useLlmStore((state) => state.llmLabel);

	// Show disclaimer for modes that reference Help Center content (for now, only Product Answers)
	const showHelpCenterDisclaimer = llmLabel === 'Product Answers';

	return (
		<Flex
			flexDirection="column"
			alignItems="center"
			justifyContent="space-between"
			overflow="hidden"
			height="100%"
		>
			<div className="chatLogRowWrapper">
				{chatLog.length > 0 &&
					chatLog.map((chat, idx) => (
						<ChatLogRow
							chat={chat}
							chatLogRef={chatLogRef}
							key={`${idx}-navPrompt-${chat.chatPrompt.replace(/[^a-zA-Z0-9]/g, '-')}`}
							isLast={idx === chatLog.length - 1}
							hasPrinted={hasPrinted}
							setHasPrinted={setHasPrinted}
							isPrinting={isPrinting}
							setIsPrinting={setIsPrinting}
						/>
					))}
			</div>

			<Flex
				marginY="20px"
				justifyContent="center"
				maxWidth={'800px'}
				width={'80%'}
				flexDirection="column"
				gap="8px"
			>
				<ChatPromptInput
					handleSubmit={handleSubmit}
					isPrinting={isPrinting}
					setIsPrinting={setIsPrinting}
					chatLogRef={chatLogRef}
				/>
				{showHelpCenterDisclaimer && (
					<BodyText justify="center" size="extra-extra-small" color="neutral-weak">
						Some Help Center articles require Salesforce access—
						<Link
							href="https://bamboohr.slite.com/app/docs/qA1_51QmOTRZQl?source=breadcrumb"
							target="_blank"
							rel="noreferrer"
						>
							create a demo account
						</Link>{' '}
						to view all Help Center content and BambooHR Learning resources.
					</BodyText>
				)}
			</Flex>
		</Flex>
	);
};
